module.exports = __webpack_public_path__ + "img/product-options-example.d1e4938a.svg";